import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CustomerReportCellsRebuildRequest } from '../models/api/customerReportCellsRebuildRequest';
import { CustomerReportCellsRebuildResult } from '../models/api/customerReportCellsRebuildResult';
import { CustomerReportRebuildLog } from '../models/api/customerReportRebuildLog';

@Injectable({
  providedIn: 'root'
})
export class CustomerReportCellsService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/tools/customer-report-cells`;

  /**
   * POST /api/tools/customer-report-cells/rebuild
   * Experimental: rebuilds the precalculated company-report cells table.
   * Long-running — the call returns only when the rebuild finishes.
   */
  rebuild(request: CustomerReportCellsRebuildRequest): Observable<CustomerReportCellsRebuildResult> {
    return this.http.post<CustomerReportCellsRebuildResult>(`${this.apiUrl}/rebuild`, request);
  }

  /**
   * GET /api/tools/customer-report-cells/history
   * Recent rebuild executions (scheduled or manual), newest first.
   */
  getHistory(take = 10): Observable<CustomerReportRebuildLog[]> {
    return this.http.get<CustomerReportRebuildLog[]>(`${this.apiUrl}/history`, { params: { take } });
  }
}
